var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative",
      "min-height": "600px"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticStyle: {
      position: "relative"
    }
  }, [_vm.styleObj.controlsComponentsMark == "productList1" ? _c("div", {
    staticClass: "listBox"
  }, _vm._l(5, function (index) {
    return _c("div", {
      key: index + 1,
      staticClass: "item",
      style: {
        fontSize: _vm.styleObj.productListModule.productNameFontSize + "px",
        color: _vm.styleObj.productListModule.productNameColor,
        border: `1px solid ${_vm.styleObj.productListModule.productButtonBorderColor}`,
        backgroundColor: _vm.styleObj.productListModule.productButtonBgColor
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("产品保险")) + _vm._s(index) + " ")]);
  }), 0) : _vm._e(), _vm.styleObj.controlsComponentsMark == "productList2" ? _c("div", {
    staticClass: "listBox"
  }, _vm._l(4, function (index) {
    return _c("div", {
      key: index + 1,
      staticClass: "productItem",
      style: {
        border: `1px solid #D7D7D7`,
        backgroundColor: "#fff"
      }
    }, [_c("div", {
      staticClass: "img"
    }, [_vm._v(_vm._s(_vm.$t("产品主图")))]), _c("div", {
      staticClass: "rightCont",
      style: {
        fontSize: _vm.styleObj.productListModule.otherFieldsFontSize + "px",
        color: _vm.styleObj.productListModule.otherFieldsColor
      }
    }, [_c("div", {
      style: {
        fontSize: _vm.styleObj.productListModule.productNameFontSize + "px",
        color: _vm.styleObj.productListModule.productNameColor
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("产品名称")) + " ")]), _c("div", [_vm._v(" " + _vm._s(_vm.$t("本产品由xxx承保")) + " ")]), _c("div", {
      staticClass: "price"
    }, [_vm._v("150.00" + _vm._s(_vm.$t("元")) + _vm._s("（" + _vm.$t(`起`) + "）"))])])]);
  }), 0) : _vm._e(), _vm.styleObj.landingPageModuleDisplay && _vm.pageModuleShow == 2 ? _c("div", {
    staticClass: "landingPage"
  }, [_c("div", {
    staticClass: "bgBox"
  }, [_vm.styleObj.landingPageModule.backgroundImage ? _c("img", {
    attrs: {
      src: _vm.styleObj.landingPageModule.backgroundImage,
      alt: ""
    }
  }) : _c("div", [_vm._v(_vm._s(_vm.$t("背景图展示区")))])]), _c("div", {
    staticClass: "buttonBox"
  }, _vm._l(_vm.styleObj.landingPageModule.buttonInfo, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "button",
      style: {
        fontSize: item.buttonFontSize + "px",
        color: item.buttonFontColor,
        backgroundColor: item.buttonBgColor,
        border: `1px solid ${item.buttonFontColor}`
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          index === 0 ? _vm.changePageShow() : "";
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.buttonName) || _vm.$t("按钮文案") + (index + 1)) + " ")]);
  }), 0)]) : _vm._e()]), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };